module.exports = function (preview) {
  var _window$location;
  var esc = function esc(value) {
    return preview.app.browser.escapeHTML(String(value !== null && value !== void 0 ? value : ''));
  };
  var hrefUrl = preview.app.browser.isSafeHref(preview.url) ? preview.url : '#';
  var isLocal = preview.url && typeof window !== 'undefined' && ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.host) && String(preview.url).includes(window.location.host);
  var html = "\n  <div class=\"saito-link-preview\">\n          <a ";
  var info = ['title', 'display_url', 'description'];
  var include_graphics = true;
  if (!isLocal) {
    html += "target=\"_blank\" rel='noopener noreferrer' ";
  } else {
    html += "data-link=\"local_link\" ";
    var index = preview.url.indexOf(window.location.host) + window.location.host.length + 1;
    var slug = preview.url.substring(index);
    if (slug.includes('/')) {
      slug = slug.split('/')[0];
    }
    if (slug.includes('?')) {
      slug = slug.split('?')[0];
    }
    var filters = preview.app.modules.returnFirstRespondTo('saito-filter-link', {
      modname: preview.mod.returnName(),
      slug: slug,
      url: preview.url
    });
    if (filters !== null && filters !== void 0 && filters.info) {
      info = filters === null || filters === void 0 ? void 0 : filters.info;
    }
    if (filters !== null && filters !== void 0 && filters.no_photo) {
      include_graphics = false;
    }
  }
  var img_src = '/saito/img/dreamscape.png';
  if (preview.src && preview.app.browser.isSafeMediaUrl(preview.src)) {
    img_src = preview.src;
  }
  html += "href=\"".concat(esc(hrefUrl), "\">");
  if (include_graphics) {
    html += "<div class=\"saito-link-preview-img ".concat(preview.show_photo ? 'has-picture' : '', "\">\n                <img src=\"").concat(esc(img_src), "\">\n              </div>");
  }
  if (info.length > 0) {
    html += "<div class=\"saito-link-preview-info\">";
    for (var i = 0; i < info.length; i++) {
      var key = info[i];
      var className = String(key).replace(/[^a-zA-Z0-9_-]/g, '');
      if (!className) {
        continue;
      }
      var content = esc(preview[key]);
      if (key === 'title' || key === 'description') {
        content = preview.app.browser.sanitizeInlineHtml(preview[key]);
      } else if (key === 'display_url') {
        content = esc(preview.app.browser.formatUrlForDisplay(preview[key]));
      }
      html += "<div class=\"saito-link-preview-".concat(className, "\">").concat(content, "</div>");
    }
    html += '</div>';
  }
  html += "\n          </a>\n        </div>\n    ";
  return html;
};